const VERSION = '3.9.4';
export default VERSION;
